import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLogo } from '../components/SiteLogo';
import { LandingHero } from '../components/landing/LandingHero';
import { TourBooking } from '../components/landing/TourBooking';
import { PackageHighlights } from '../components/landing/PackageHighlights';
import { BravoFeature } from '../components/landing/BravoFeature';
import { PressLogos } from '../components/landing/PressLogos';
import { RealWeddings } from '../components/landing/RealWeddings';
import { TestimonialBand } from '../components/landing/TestimonialBand';
import { SiteFooter } from '../components/landing/SiteFooter';
import type { LandingVariant } from '../types/landing';
type LandingPageProps = {
  variant: LandingVariant;
};
export function LandingPage({
  variant
}: LandingPageProps) {
  useEffect(() => {
    document.title = variant.pageTitle;
    window.scrollTo(0, 0);
  }, [variant]);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-121" data-mp="lmxt14gh3th3">
      <header className="flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-122" data-mp="2zj70xaz4nz8d">
        <Link to={`/${variant.slug}`} aria-label="Twenty Mile House home" className="inline-block" data-id="element-123" data-mp="33kiiqubrfg60">
          <SiteLogo size="sm" data-id="element-124" data-mp="38jvds2csbtjo" />
        </Link>
      </header>
      <main data-id="element-125" data-mp="38iaigainc6kr">
        <LandingHero eyebrow={variant.eyebrow} headline={variant.headline} data-id="element-126" data-mp="38hinn1wvicvj" />
        <TourBooking data-id="element-127" data-mp="3dbwk77n9uq1s" />
        <PackageHighlights stats={variant.stats} data-id="element-128" data-mp="3dcenupc9k6jq" />
        <BravoFeature data-id="element-129" data-mp="3i8d9w6a4dcgz" />
        <PressLogos data-id="element-130" data-mp="3i8wq9ik4fssw" />
        <RealWeddings data-id="element-131" data-mp="3ibj2vwlvcyhz" />
        <TestimonialBand data-id="element-132" data-mp="3n89fub2dndz6" />
      </main>
      <SiteFooter data-id="element-133" data-mp="3n76mzxlhv1gm" />
    </div>;
}